import React from "react";
import { DateWithTooltip } from "components/DateWithTooltip";
import { styled } from "@mui/material/styles";

export interface TextStreamItemProps {
  text: string;
  date?: string;
}

export default function TextStreamItem({
  text,
  date
}: TextStreamItemProps): JSX.Element {
  return (
    <Wrapper>
      <Line />
      <TextWrapper>
        {text}&nbsp;
        {date && <DateWithTooltip date={date} showTime />}
      </TextWrapper>
      <Line />
    </Wrapper>
  );
}

const Wrapper = styled("div")`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
`;

const TextWrapper = styled("span")`
  text-align: center;
`;

const Line = styled("span")`
  flex-grow: 1;
  height: 1px;
  background-color: #999;
  min-width: 50px;
`;
